export default "/_next/static/images/524e5c408bfdbdee277a48e08dd5f405.jpg";